import * as React from "react";
const SvgBolt = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 448 512", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16 288L320 0 260.7 197.6 432 224 128 512l59.3-197.6L16 288z" }));
export default SvgBolt;
